export default __webpack_public_path__ + "static/media/GTaboutIcon.b1199db7.svg";